export default __webpack_public_path__ + "static/media/plain-sticker-S.9e0eac74.png";